var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _path7, _circle6, _circle7, _circle8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmergencyAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05658 21.7358V27.1698H21.7358",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8113 42.5659L49.8113 38.0376L37.1321 38.0376",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05658 42.5659V38.0376H21.7358",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3396 32.6038H19.9245",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9434 32.6038H52.5283",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8113 21.7358L49.8113 27.1698L37.1321 27.1698",
    stroke: "#4B4A50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.0566,
    cy: 19.9246,
    r: 2.62264,
    fill: "#4B4A50",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8113,
    cy: 19.9246,
    r: 2.62264,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.0566,
    cy: 44.3773,
    r: 2.62264,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.62264,
    cy: 32.6038,
    r: 2.62264,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.8113,
    cy: 44.3773,
    r: 2.62264,
    fill: "#4B4A50",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2642 42.5659V20.8301H32.6038V24.5282L30.7925 26.264L32.6038 28.0754L30.7925 29.8867L32.6038 31.698V35.6225L30.7925 37.132L32.6038 38.9433V42.5659L30.7925 44.3772H28.0755L26.2642 42.5659Z",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.434,
    cy: 11.3208,
    r: 10.3208,
    fill: "#FFEFF0",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.434,
    cy: 7.69813,
    r: 2.16981,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2453,
    cy: 32.6038,
    r: 2.62264,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmergencyAccess);
export default __webpack_public_path__ + "static/media/icon-emergency-access.3657c128c0830cd660cbe08ec218233b.svg";
export { ForwardRef as ReactComponent };